import PropTypes from "prop-types"

const Fragment = (props) => {
    return (
        props.rendered ? props.children : null
    )
}

Fragment.propTypes = {
    rendered: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

export default Fragment;